import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames/bind';
import Icon from 'src/common/components/IconDS22';
import { useSearchInputContext, type SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import ClearButton from 'src/common/components/Search/Inputs/ClearButton';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import type { SearchHeroProps } from 'src/common/components/Search/SearchHero';
import styles from '../Inputs.module.scss';

const cx = classNames.bind(styles);
export type InputGuestsProps = {
  refs?: Partial<SearchRefs>;
  closeIconId?: 'x' | 'x-circle';
  variant?: SearchHeroProps['variant'];
};

const InputGuests: FC<InputGuestsProps> = ({
  refs,
  closeIconId = 'x',
  variant,
}) => {
  const {
    setFilterGuests, filterGuests,
  } = useSearchInputContext();

  const { isGuestsOpen, opening, openGuests } = useSearchHeroModalContext();
  const { t } = useTranslation('common');

  const showIcon = variant === 'hero' || variant === 'sheet';

  const showClear = isGuestsOpen && filterGuests > 0;

  return (
    <label
      className={cx(styles.label, `${variant}Variant`, {
        isOpen: isGuestsOpen || opening === 'guests',
      })}
      tabIndex={-1}
    >
      {showIcon && (
        <div className={styles.icon}>
          <Icon
            id="people"
            size="l"
            data-test="who"
          />
        </div>
      )}
      <input
        // Keydown is not needed here, as focus is transferred to a popup
        readOnly
        ref={refs?.who}
        onFocus={openGuests}
        className={cx(styles.input, `${variant}Variant`, { showIcon, showClear })}
        onClick={openGuests}
        placeholder={t('search--search-who-placeholder')}
        value={filterGuests ? t('search--search-guest-placeholder', { count: filterGuests }) : ''}
        name="who-input"
        enterKeyHint="search"
        data-test="whoSearchInput"
        data-cwv="search--who"
      />
      { showClear && (
        <ClearButton
          onClick={() => setFilterGuests(0)}
          closeIconId={closeIconId}
        />
      )}
    </label>
  );
};

export default InputGuests;
